import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Paper from '@material-ui/core/Paper'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/fontawesome-free-solid'

import { MyCalendar, CircularProgress } from '../../../common'
import MenuHeader from '../../../containers/MenuHeader'
import OfflineModeHeader from '../../../containers/OfflineModeHeader'
import BookingSystemItems from '../../../containers/BookingSystemItems'

import * as Strings from './strings'
import * as Styles from './styles'
import * as Constants from '../../../../helpers/Constants'
import * as Functions from '../../../../helpers/Functions'
import * as userActions from '../../../../actions/User'
import * as bookingSystemActions from '../../../../actions/BookingSystems'
import * as offlineModeActions from '../../../../actions/OfflineMode'

const TODAY = new Date()

class BookingSystem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chosenDate: TODAY,
      width: window.innerWidth,
      hover: null
    }

    this.resizeHandler = this.resizeHandler.bind(this)
  }

  componentDidMount() {
    const { history, user, offlineMode, data } = this.props

    window.addEventListener('resize', this.resizeHandler)
    if (offlineMode) {
      if (!user.offlineModeSignedIn) {
        this.props.setOfflineSetup()
      }
    } else if (!user.fetched) {
      history.push('/')
    } else if (!data.bookingSystemsFetched) {
      this.props.tryGetBookingSystems(user.token)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler)
  }

  resizeHandler() {
    this.setState({ width: window.innerWidth })
  }

  handleChangeDate = (event, date) => {
    this.setState({ chosenDate: date })
  }

  idIsPresentAndExists() {
    const { match, data } = this.props

    if (!match.params.id || !data.bookingSystemsFetched) {
      return false
    }

    let isPresent = false

    Object.keys(data.bookingSystems).forEach(key => {
      if (key.toString() === match.params.id.toString()) {
        isPresent = true
      }
    })

    return isPresent
  }

  renderBookingSystems() {
    const { hover } = this.state
    const { data, config, history, offlineMode, user } = this.props
    const systems = []

    Object.keys(data.bookingSystems).forEach(key => {
      const system = data.bookingSystems[key]

      systems.push(
        <Item
          header={system.name}
          onMouseEnter={() => this.setState({ hover: system.id })}
          onMouseLeave={() => this.setState({ hover: null })}
          hover={hover === system.id}
          onClick={
            offlineMode
              ? () => history.push('/testmode/bookingsystems/' + system.id)
              : () => history.push('/bookingsystems/' + system.id)
          }
        />
      )
    })

    if (systems.length === 0 && user.isAdmin) {
      return <p>{Strings.default.NO_BOOKING_SYSTEMS_ADMIN[config.language]}</p>
    }

    if (systems.length === 0) {
      return <p>{Strings.default.NO_BOOKING_SYSTEMS[config.language]}</p>
    }

    return systems
  }

  renderCalendarBooking() {
    const { offlineMode, data, match } = this.props
    const { width, chosenDate } = this.state
    const system = data.bookingSystems[match.params.id]

    if (width > 937) {
      return (
        <div
          style={{
            ...Styles.default.bookingsContainer,
            marginTop: offlineMode ? 65 : 25
          }}
        >
          <BookingSystemItems date={chosenDate} system={system} />
        </div>
      )
    }

    return <BookingSystemItems date={chosenDate} system={system} />
  }

  renderCalendar() {
    const { offlineMode, config, data, match } = this.props
    const { width, chosenDate } = this.state
    const availabilityStatus = {}
    let maxDate = new Date()

    if (this.idIsPresentAndExists()) {
      const system = data.bookingSystems[match.params.id]
      const today = new Date()
      const allBookings = []
      const availability = {}
      let timesLeftToday = 0

      if (system.bookingRange !== 0) {
        maxDate.setDate(maxDate.getDate() + 7 * system.bookingRange)
      } else {
        maxDate = null
      }

      system.times.map(time => {
        if (parseInt(time.end.split(':')[0]) > parseInt(today.getHours()))
          timesLeftToday++
        time.bookings.forEach(booking => allBookings.push(booking))
      })

      //Saves availability
      allBookings.forEach(booking => {
        const bookingDate = new Date(booking.date)
        const date = Functions.formatDate(bookingDate)

        if (availability[date]) {
          availability[date] = availability[date] + 1

          if (
            (Functions.compareDate(bookingDate, new Date()) &&
              availability[date] >= timesLeftToday) ||
            availability[date] >= system.times.length
          )
            availabilityStatus[date] = 'red'
        } else {
          availability[date] = 1
          if (timesLeftToday === 1) availabilityStatus[date] = 'red'
        }
        if (booking.apartmentId === data.apartment.id) {
          availabilityStatus[date] = 'green'
        }
      })
    }

    const container =
      width > 937
        ? Styles.default.fullScreenCalendarContainerStyle
        : Styles.default.halfScreenCalendarContainerStyle

    return (
      <div style={{ ...container, marginTop: offlineMode ? 65 : 25 }}>
        <MyCalendar
          ref={'calendar'}
          onChange={(event, date) => {
            this.handleChangeDate(event, date)
          }}
          minDate={TODAY}
          maxDate={maxDate}
          chosenDate={chosenDate}
          availabilityStatus={availabilityStatus}
          locale={Strings.default.CALENDAR_LANGUAGE[config.language]}
        />
      </div>
    )
  }

  getContainerStyle() {
    const { width } = this.state

    return {
      display: 'flex',
      alignItems: width > 937 ? 'flex-start' : 'center',
      flexDirection: width > 937 ? 'row' : 'column',
      minHeight: '100vh',
      marginTop: 100
    }
  }

  renderContent() {
    const { data, user, offlineMode, history } = this.props

    if (!user.fetched && !offlineMode) {
      history.push('/')
    }

    if (!user.fetched || !data.bookingSystemsFetched) {
      return <CircularProgress />
    }

    if (this.idIsPresentAndExists()) {
      return (
        <div style={this.getContainerStyle()}>
          {this.renderCalendar()}
          {this.renderCalendarBooking()}
        </div>
      )
    }

    return (
      <div
        style={{
          ...Styles.default.container,
          paddingTop: offlineMode ? 150 : 100
        }}
      >
        {this.renderBookingSystems()}
      </div>
    )
  }

  render() {
    const { config, data, history, match } = this.props
    const header = this.idIsPresentAndExists()
      ? Strings.default.BOOK[config.language] +
        ' ' +
        data.bookingSystems[match.params.id].name.toLowerCase()
      : Strings.default.SELECT_BOOKING_SYSTEM[config.language]

    return (
      <MenuHeader
        history={history}
        header={header}
        selected={Constants.BOOKING_SYSTEM_FOCUSED}
      >
        <OfflineModeHeader history={history} />
        {this.renderContent()}
      </MenuHeader>
    )
  }
}

const Item = ({ header, onMouseEnter, onMouseLeave, hover, onClick }) => {
  return (
    <Paper
      style={Styles.default.paperContainer}
      className={'hover'}
      onMouseEnter={() => onMouseEnter()}
      onMouseLeave={() => onMouseLeave()}
      onClick={() => onClick()}
    >
      <div style={Styles.default.innerPaperContainer}>
        <p style={Styles.default.text}>{header}</p>
      </div>
      <FontAwesomeIcon
        icon={faChevronRight}
        style={{
          ...Styles.default.icon,
          color: hover
            ? Constants.WHITE_LABEL.colors.primaryHover
            : Constants.WHITE_LABEL.colors.primary
        }}
      />
    </Paper>
  )
}

function mapStateToProps({ user, config, data }) {
  return { user, data, config }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...userActions,
      ...bookingSystemActions,
      ...offlineModeActions
    },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookingSystem)



// WEBPACK FOOTER //
// ./src/components/pages/bookingSystems/BookingSystem/index.js